import styled from 'styled-components'

import commonCss from '~/core/css'

export const H1 = styled.h1`
  ${commonCss.resetBoxProps};

  font-weight: 600;
  font-size: 36px;
  line-height: 48px;
`

export const H2 = styled.h2`
  ${commonCss.resetBoxProps};

  font-weight: 600;
  font-size: 24px;
  line-height: 1.33;
`

export const H4 = styled.h4`
  ${commonCss.resetBoxProps};

  font-size: 19px;
  font-weight: 600;
  line-height: 28px;

  color: #5e6d7a;
`
